<template>
 <div >
    <div class="detailsTitle">
      <h4>上报记录</h4>
        <div @click="back"><i class="fa fa-reply"></i></div>
    </div>
   <div class="searchBox" ref="searchBox">
      <el-form :inline="true" ref="" class="demo-form-inline" label-width="120px" size="mini">
        <div class="searchBox inpBox">
            <div class="item">
              <el-form-item label="纳税人名称:" prop="taxpayerName">
                <el-input  placeholder="" v-model="searchFrom.taxpayerName"></el-input>
              </el-form-item>
              <el-form-item label="上报状态:" prop="reportStatus">
                  <el-select  v-model="searchFrom.reportStatus"   placeholder="请选择">
                    <el-option label="上报成功" value="1"></el-option>
                    <el-option label="上报失败" value="0"></el-option>
                  </el-select>
                </el-form-item>
              <el-form-item label="产生税费年月:" prop="taxDate">
              <el-date-picker
                      v-model="searchFrom.taxDate"
                      :editable="false"
                      :clearable="false"
                      type="month"
                      format="yyyy-MM"
                      value-format="yyyy-MM"
                      placeholder="请选择年月">
              </el-date-picker>
              </el-form-item>
            </div>
        </div>
       <div class="searchBtnBox">
          <el-form-item>
            <el-button type="primary" @click="searchFn">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="resetForm('searchFrom')">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :disabled="isDisable" @click="exportFn">导出</el-button>
          </el-form-item>
          <!-- <el-form-item>
            <el-button type="primary" @click="reportFN">上报</el-button>
          </el-form-item> -->
       </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList"  ref="table" v-loading="loading"   bordersize="mini"  @selection-change='selectGoods' height="100%" style="width: 100%" center border>
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" fixed prop="date" width="55" label="序号"></el-table-column>
        <!-- <el-table-column property="reportStatus" label="状态" width="120">
          <template scope="scope">{{[ "上报失败", "上报成功"][scope.row.reportStatus]}}</template>
        </el-table-column> -->
        <el-table-column property="reportStatus" label="状态">
          <template scope="scope">
            <div>
              <span style="color:red" v-if="scope.row.reportStatus==0">上报失败</span>
              <span v-if="scope.row.reportStatus==1">上报成功</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="taxDate"  width="170"  :formatter="emptyFn"   label="产生税费年月"> </el-table-column>
        <el-table-column property="fwfuuid" width="220"  :formatter="emptyFn"   label="平台服务方"></el-table-column>
        <el-table-column property="taxpayerName" width="160"  :formatter="emptyFn"   label="纳税人名称"></el-table-column>
        <el-table-column property="taxpayerIdNo"  width="190"  :formatter="emptyFn"   label="纳税人识别号"></el-table-column>
        <el-table-column property="legalRepresentative"  width="120"  :formatter="emptyFn"   label="法定代表人姓名"></el-table-column>
        <el-table-column width="170" property="legalRepresentativeIdentifyNo" :formatter="emptyFn" label="法定代表人身份证号"></el-table-column>
        <el-table-column property="businessAddress"  width="180"  :formatter="emptyFn"   label="生产经营地址" show-overflow-tooltip></el-table-column>
        <el-table-column width="160" property="businesScope" :formatter="emptyFn" label="经营范围" show-overflow-tooltip></el-table-column>
        <el-table-column width="170" property="agent" :formatter="emptyFn" label="经办人"></el-table-column>
        <el-table-column width="170" property="agentIdentityCode" :formatter="emptyFn" label="经办人身份证件类型"></el-table-column>
        <el-table-column property="agentIdentityNo" width="170" :formatter="emptyFn" label="经办人身份证件号码"></el-table-column>
        <el-table-column width="170" property="reportDate" :formatter="dateTimeFormat" label="上报时间"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[25,50,100]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 上报 -->
    <!-- <el-dialog title="提示"
    @close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :visible.sync="reportMark"
    width="400px"
    center>
      <div>
        <span style="text-align: center;display:block;margin:40px 0">上报后不能取消，确认上报吗?</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reportMark = false">取 消</el-button>
        <el-button type="primary" @click="recallSave">确 定</el-button>
      </span>
    </el-dialog> -->
 </div>

</template>

<script>
import { getBtn } from '@/utils/getButton'
import { emptyFn, dateTimeFormat } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import {
  getReportRecordList // 列表
  // recycleMoney // 个税上报
} from '@/api/consignment'
export default {
  data () {
    return {
      reportMark: false,
      recallId: '',
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      h: '500px',
      // 查询调价
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      loading: false,
      total: 0,
      HZfrom: {},
      isDisable: false,
      btnFlg: [],
      btnIdArr: ['00JP00LB001', '00JP00LB002', '00JP00LB003', '00JP00LB004']
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/paymenWithholding/taxDeclaration')
    this.$set(this.searchFrom, 'taxDate', this.getLastMonth())
    this.getList(this.searchFrom)
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 135) + 'px'
  },
  methods: {
    back () {
      this.$router.go(-1)// 返回上一层
    },
    // reportFN (row) {
    //   const selectData = this.$refs.table.selection
    //   if (selectData.length < 1) {
    //     this.$alert('请选择要操作的数据', '系统提示')
    //   } else {
    //     this.ids = []
    //     selectData.some((item, index) => {
    //       console.log(item)
    //       this.ids.push(item.id)
    //       console.log(this.ids)
    //       this.$set(this, 'recallId', this.ids)
    //       this.reportMark = true
    //     })
    //   }
    // },
    // recallSave () {
    //   const loading = this.$loading({
    //     lock: true,
    //     text: '正在处理...'
    //   })
    //   recycleMoney({ id: this.recallId }).then(res => {
    //     loading.close()
    //     this.$message({
    //       message: '上报成功',
    //       type: 'success'
    //     })
    //     this.reportMark = false
    //     this.getList(this.searchFrom)
    //   }).catch(error => {
    //     this.$message({
    //       showClose: true,
    //       message: error.message,
    //       type: 'error',
    //       onClose () {
    //         loading.close()
    //       }
    //     })
    //   })
    // },
    // 获取年月
    getLastMonth () { // 获取上个月日期
      var date = new Date()
      var year = date.getFullYear()
      var month = date.getMonth() < 10 ? '0' + date.getMonth() : date.getMonth()
      if (month == 0) {
        year = year - 1
        month = 12
      }
      return year + '-' + month
    },
    // 导出
    exportFn () {
      let form = { ...this.searchFrom }
      exportExcel(
        this.global.payServer + '/sTaxationSummary/exportReportRecordList',
        form,
        '上报列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      if (this.searchFrom.cargoBarcodes) { this.searchFrom.cargoBarcodes = this.searchFrom.cargoBarcodes.split(/[(\r\n)\r\n]+/) }

      this.getList(this.searchFrom)
    },
    // 选择数据
    selectGoods (selection) {
      // console.log(selection)
      this.weight = 0.00
      selection.forEach(item => {
        this.weight += item.weight
      })
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList (searchFrom) {
      this.loading = true
      getReportRecordList(searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    billDetails (row) {
      this.$router.push({ name: 'billDetails', query: { billId: row.id } })
    },
    // 重置
    resetForm (formName) {
      // debugger
      // this.$refs[formName].resetFields()
      // this.searchFrom.createTime=null
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
        // taxDate: this.getLastMonth()
      }
    },
    closeDialog () {
      this.addForm = {}
      this.CHFrom = {}
    }
  }
}
</script>

<style scoped lang='less'>
.inpBox .el-date-editor{
      width: 350px!important;
}
.fontStyle{
  font-size: 20px;
  color: red;
}
/deep/.el-divider--horizontal{
  margin-top: 14px;
}

</style>
<style lang="css"> .el-tooltip__popper{ max-width:25% } </style>
